module.exports = __webpack_public_path__ + "devfont.eot?c00d179063007ab9e5af4fc514b5679c";